module.exports = __webpack_public_path__ + "static/img/caseImg3.b7457ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/caseImg3.jpg
// module id = xhAw
// module chunks = 0